import { useState, useCallback } from 'react'
import axios from 'axios'
import { apiClient } from '@/libs/api_client'
import { useAuthStore } from '@/stores/auth'

interface SendTestEmailResult {
  to: string
  from: string
  subject: string
  result: string
}

export function useSystemToolsEmail() {
  const [isLoading, setIsLoading] = useState(false)
  const token = useAuthStore((state) => state.token)

  const getAuthHeaders = useCallback(() => {
    return token ? { Authorization: `Bearer ${token}` } : {}
  }, [token])

  const sendTestEmail = useCallback(
    async (params: {
      to: string
      subject?: string
      content?: string
    }): Promise<SendTestEmailResult> => {
      setIsLoading(true)

      try {
        const response = await apiClient.post<{
          success: boolean
          data: SendTestEmailResult
          error?: string
        }>('/api/system-tools/email/test', params, { headers: getAuthHeaders() })

        if (!response.data.success) {
          throw new Error(response.data.error || '發送失敗')
        }

        return response.data.data
      } catch (err) {
        let message: string | undefined
        if (axios.isAxiosError<{ error?: { message?: string } | string }>(err)) {
          const responseError = err.response?.data?.error
          message =
            (typeof responseError === 'string' ? responseError : responseError?.message) ||
            err.message
        } else if (err instanceof Error) {
          message = err.message
        }
        throw new Error(message || '發送測試 Email 失敗')
      } finally {
        setIsLoading(false)
      }
    },
    [getAuthHeaders],
  )

  return {
    sendTestEmail,
    isLoading,
  }
}
